import { render } from "./CriteriaSection.vue?vue&type=template&id=0f2df95a&scoped=true"
import script from "./CriteriaSection.vue?vue&type=script&lang=js"
export * from "./CriteriaSection.vue?vue&type=script&lang=js"

import "./CriteriaSection.vue?vue&type=style&index=0&id=0f2df95a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f2df95a"]])

export default __exports__